import React from "react";
import {Button} from "../../components/Button";

const ReportingConnectionFailedPage: React.FC<{ onRefresh: () => void }> = ({onRefresh}) => {
    return (
        <div className="connection-failed display-flex justify-content-center align-items-center">
            <div className="connection-failed__container">
                <span className="connection-failed__header">Failed to generate report</span>
                <br />
                <span className="connection-failed__footer">
                    There was an error generating report. Please try again.
                    </span>
                <br />
                <span className="connection-failed__footer">
                    If the problem persists, contact the GPI IT SUPPORT at GPIITSUPPORT@ntrs.com
                </span>
                <br />
                <Button
                    className="margin-lg"
                    icon="left"
                    iconName="refresh"
                    rounded
                    size="medium"
                    onClick={onRefresh}
                >
                    RETRY
                </Button>
            </div>
        </div>
    )
};

export default ReportingConnectionFailedPage;